// extracted by mini-css-extract-plugin
export default {"scope":"fzYaA","scope--is-to-short":"sSng7","scope--is-to-long":"I35EV","scope--is-empty":"+VbZZ"};